import { apiServer } from 'settings/web-services/api';

export function getEvents() {
  return apiServer.get('/audit-events/configs');
}

export function triggerMockEvent(data: { topic: string; subEvent: string; eventName: string }) {
  return apiServer.post('/audit-events/trigger-mock-event', data);
}
